import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { ViewForSelectorComponent } from '../view-for-selector/view-for-selector.component'
import { getMonthOptions } from 'src/app/services/common/common.service'

@Component({
  selector: 'app-select-period-selector',
  templateUrl: './select-period-selector.component.html',
  styleUrls: ['./select-period-selector.component.scss']
})
export class SelectPeriodSelectorComponent implements OnInit {
  @Output() dataEvent: EventEmitter<DateRange> = new EventEmitter<DateRange>()
  public static readonly defaultValue = null
  selectedValue: string
  options: any[]
  constructor() {}

  ngOnInit(): void {
    this.selectedValue = SelectPeriodSelectorComponent.defaultValue
    this.options = this.buildViewForOption()
  }

  onSelectChange(selectedValue: string) {
    let begin = null
    let end = null
    if (selectedValue) {
      const daterange = selectedValue.split('^')
      begin = new Date(daterange[0])
      end = new Date(daterange[1])
    }
    return this.dataEvent.emit({ begin, end })
  }

  buildViewForOption() {
    const options = getMonthOptions()
    options.unshift({
      key: null,
      value: 'ALL'
    })
    return options
  }
}

export interface DateRange {
  begin: Date
  end: Date
}
